'use strict';

/* Controllers */

app.controller('EnterCustomMoneyController', ['$scope', '$rootScope', '$location', 'Helper', 
    function ($scope, $rootScope, $location, Helper) {

        // init scope vars
        $scope.custom_amount = 25;


        /**
         * submit custom amount
         */
        $scope.submitCustomAmount = function(){
            // add selection to root scope
            $rootScope.globals.selectedMoney = {
                amount: $scope.custom_amount,
            }

            // redirect
            $scope.closeThisDialog('submited');
        }
    }]);